enum ActivitySelection {
  'dontMoveTeeth' = 'dontMoveTeeth',
  'dontPlaceTeeth' = 'dontPlaceTeeth',
  'biteRampTeeth' = 'biteRampTeeth',
  'treatArches' = 'treatArches',
  'extractionTeeth' = 'extractionTeeth',
}

export { ActivitySelection }
